<template>
    <div class="orderbox">
        <!-- left -->
        <filterBoxOne ref='filterBoxOne' @handleSearch="handleSearch" :buyerTypes="buyerTypes" :tabIndex="tabIndex"/>
        <!-- right -->
        <div class="main-cotent">
            <!-- tabs todo-ljm -->
            <vs-tabs v-model="tabIndex">
              <vs-tab :label="item.name" v-for="(item,index) in vsTabsList" :key="index" @click="orderTabChange(item,index)">
                <div class="top-search">
                    <div v-if="filtering('bill:order:manual')" class="search-item order-manually pointer">
                        <div class="content">
                            <img class="search-icon" src="../../../src/assets/images/orderimg/sdxd.png" alt="" />
                            <span style="color:rgb(100, 100, 100)" class="search-label">手动下单</span>
                        </div>
                        <vs-dropdown>
                            <i class="material-icons">expand_more</i>
                            <vs-dropdown-menu>
                                <vs-dropdown-item style="width:100px" @click="createOrder">创建订单</vs-dropdown-item>
                                <vs-dropdown-item style="width:100px" @click="isShowPopImportOrder = true">批量导入</vs-dropdown-item>
                            </vs-dropdown-menu>
                        </vs-dropdown>
                    </div>
                    <div @click="verifyConfirm" v-if="filtering('bill:order:confirm')" class="search-item pointer">
                        <img class="search-icon" src="../../../src/assets/images/orderimg/shqr.png" alt="" />
                        <span class="search-label">审核确认</span>
                    </div>
                    <div @click="cancelOrder" v-if="filtering('bill:order:cancel')" class="search-item pointer">
                        <img class="search-icon" src="../../../src/assets/images/orderimg/qxdd.png" alt="" />
                        <span class="search-label">取消订单</span>
                    </div>
                    <div class="search-item search-item-border pointer " v-if="filtering('bill:order:export')" @click.stop="download()">
                        <img class="search-icon" src="../../../src/assets/images/orderimg/dc.png" alt="">
                        <span class="search-label">导出订单</span>
                    </div>
                </div>
                <div class="contentlist">
                     <el-table  :height="orderdatalist.length > 0 ? orderHeight : '120'" border ref="orderListTable" :data="orderdatalist" style="width: 100%" highlight-current-row @selection-change="selectCurrentChange" @row-click="newCurrentChange">
                        <template slot="empty">
                            <p style="text-align:left; padding-left:20%;">暂无数据</p>
                        </template>
                        <el-table-column type="selection" width="55" ></el-table-column>
                        <el-table-column prop="orderNo" label="订货单号" fixed="left" width="160" align="center" >
                            <template slot-scope="scope">
                                 <div class="excrete-logo" v-if="scope.row.parentOrderNo">分</div>
                                  <div class="excrete-logo" v-if="scope.row.combineType=='combine_ed'">合</div>
                                  {{ scope.row.orderNo }}<br>{{scope.row.bodyName}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="orderTime" label="订单日期" width="150" align="center" ></el-table-column>
                        <el-table-column prop="skuSummary" label="商品信息" width="100" align="center">
                            <template slot-scope="scope">
                                <el-popover
                                    placement="bottom"
                                    width="800"
                                    @show="ncrFormat(scope.row)"
                                    @hide="Purchaseorderlist=[]"
                                    trigger="hover">
                                    <el-table v-loading="loadingasd" style="max-height:480px;overflow: auto;" border :data="Purchaseorderlist" :row-class-name="tableRowClassName">
                                        <el-table-column width="100" align="center" property="goodsCategoryName" label="商品类别"></el-table-column>
                                        <el-table-column width="100" align="center" property="skuCode" label="商品编码"></el-table-column>
                                        <el-table-column width="150" align="center" property="skuName" label="商品名称"></el-table-column>
                                        <el-table-column width="150" align="center" property="barCode" label="69码"></el-table-column>
                                        <el-table-column width="80" align="center" property="num" label="下单数量"></el-table-column>
                                        <el-table-column width="80" align="center" property="availableAmount" label="可用库存"></el-table-column>
                                        <!-- <el-table-column width="80" align="center" property="sendSpecNum" label="发货数量"></el-table-column> -->
                                        <el-table-column width="100" align="center" property="untilPrice" label="原价"></el-table-column>
                                        <el-table-column width="100" align="center" property="hunitPrice" label="成交价"></el-table-column>
                                        <el-table-column width="100" align="center" property="itemPrice" label="原价金额"></el-table-column>
                                        <el-table-column width="100" align="center" property="hitemPrice" label="成交金额"></el-table-column>
                                    </el-table>
                                    <span slot="reference" style="cursor:pointer">{{scope.row.skuSummary}}</span>
                                </el-popover>
                            </template>
                        </el-table-column>
                        <el-table-column prop="orderNo" label="买家/类型" width="180" align="center" >
                            <template slot-scope="scope">
                                <div class="buyerName"> {{ scope.row.buyerName }} </div>
                                <div class="buyerType"> {{ scope.row.buyerType }} </div>
                                <div class="buyerType"> {{scope.row.buyerCode || ''}} </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="orderStatus" label="订单状态" width="100" align="center" >
                            <template slot-scope="scope">
                                <span class="order-status" :style="orderStatusColorStyle(scope.row.orderStatus)"></span>
                                {{ scope.row.orderStatusDesc }}
                                <div v-if="scope.row.orderStatus == 'ABNORMAL'" style="color:#aaa">{{scope.row.warnMessage}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="currency" label="币种" width="80" align="center" ></el-table-column>
                        <el-table-column prop="" label="应付" width="100" align="center" >
                            <template slot-scope="scope">
                                {{scope.row.currency === 'USD'?'$'+scope.row.toPayPrice:'￥'+scope.row.toPayPrice}}
<!--                                {{!scope.row.currency?'￥'+scope.row.toPayPrice:(scope.row.currency === 'USD'?'$'+scope.row.toPayPrice:'￥'+scope.row.toPayPrice)}}-->
                            </template>
                        </el-table-column>
                        <el-table-column prop="realityTotalPrice" label="实付" width="100" align="center" >
                            <template slot-scope="scope">
                                {{scope.row.currency === 'USD'?'$'+scope.row.realityTotalPrice:'￥'+scope.row.realityTotalPrice}}
<!--                                {{ scope.row.realityTotalPrice | currencyFormat(2, false, scope.row.currencySymbol) }}-->
                            </template>
                        </el-table-column>
                        <el-table-column prop="payTime" label="付款时间" width="150" align="center" ></el-table-column>
                        <el-table-column prop="receiveName" label="收件人" width="100" align="center" ></el-table-column>
                        <el-table-column prop="receivePhone" label="联系方式" width="100" align="center" ></el-table-column>
                        <el-table-column prop="buyerRemark" label="买家备注" width="180" align="center" ></el-table-column>
                        <el-table-column prop="sellerRemark" label="卖家备注" width="180" align="center" >
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click="editBuyerRemark(scope.row)">{{ scope.row.sellerRemark || '补填' }}</el-button>
                            </template>
                        </el-table-column>
                        <el-table-column prop="" label="收货地址" width="180" align="center" >
                            <template slot-scope="scope">
                                {{ scope.row.province + scope.row.area + scope.row.address}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="billSourceDesc" label="订单来源" width="100" align="center" ></el-table-column>
                        <el-table-column prop="sourceChannelDesc" label="订单渠道" width="100" align="center" ></el-table-column>
                        <el-table-column prop="paySourceDesc" label="支付方式" width="100" align="center" >
                            <!-- <template slot-scope="scope">
                                <div v-for="(pay, payIndex) in scope.row.payTypeDescList" :key="payIndex">
                                    {{ pay }}
                                </div>
                            </template> -->
                        </el-table-column>
                        <el-table-column fixed="right" label="操作" width="220" align="center" >
                            <template slot-scope="scope">
                                <el-button type="text" size="small" @click.stop="handleCheck(scope.row, scope.$index , false)">查看</el-button>
                                <el-button v-if="filtering('bill:order:update')&&(scope.row.orderStatus=='TO_PAY'||scope.row.orderStatus=='TO_REVIEW')&&scope.row.seller=='1'" type="text" size="small" @click.stop="handleCheck(scope.row, scope.$index , true)">编辑</el-button>
                                <el-button type="text" size="small" v-if="filtering('bill:order:confirm')&&scope.row.orderStatus === 'TO_REVIEW'" @click.stop="priceCompare(scope.row, scope.$index )">审核确认</el-button>
                                <el-button type="text" size="small" v-if="filtering('bill:order:cancel')&&scope.row.orderStatus !== 'CANCEL_ED' && scope.row.orderStatus !== 'REVIEW_ED'&&scope.row.seller=='1'" @click.stop="cancelOrder(scope.row, scope.$index )">取消订单</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <gc-vs-pagination :pager="page" v-if="pageshow" totalName="totalCount" pageNoName='pagerNo' pageSizeName="pageSize" @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" ></gc-vs-pagination>
                </div>
              </vs-tab>
            </vs-tabs>

            <!-- 创建订单窗口 -->
            <vs-popup id="import-dialog" @accept="importFund()" classContent="popup-example" title="批量导入" acceptText="确认导入" cancelText="取消" :active.sync="isShowPopImportOrder">
                <div class="import-wrap con-exemple-prompt">
                    <div class="import-label">导入文件</div>
                    <div class="right-part">
                        <el-upload
                            ref="upload"
                            class="upload-demo"
                            action="/data-dist/api/dist/ordering/import/order/manual"
                            :accept="accept"
                            :show-file-list = "false"
                            :limit="1000"
                            :on-success="uploadSuccess"
                            :headers="tokenHeader"
                        >
                            <vs-button color="primary" type="filled" class="browse-btn">浏览</vs-button>
                        </el-upload>
                        <div class="downLoadText pointer" @click="downloadTemplate()">下载文件模板</div>
                    </div>
                </div>
                <!-- <vs-row style="margin-top:50px">
                    <vs-col vs-w="3" vs-offset="0.5"><vs-button color="primary" size="default" type="filled">确认导入</vs-button></vs-col>
                    <vs-col vs-w="3"><vs-button @click="isShowPopImportOrder = false" color="primary" size="default" type="border">取消</vs-button></vs-col>
                </vs-row> -->
            </vs-popup>

            <!-- 编辑卖家备注 -->
            <vs-popup classContent="popup-example deliver-pop" title="卖家备注" :active.sync="sellerRemarkPop">
                <form class="frombox" id="data-list-list-view"><vs-textarea v-model="sellerRemark" maxlength="200" class="edit-remark-textarea" /></form>
                <div class="deliver-btn flex flexCenter">
                    <vs-button color="primary" type="filled" @click="saveSellerRemark">保存</vs-button>
                    <vs-button color="primary" type="border" style="margin-left:9px;" @click="sellerRemarkPop = false">取消</vs-button>
                </div>
            </vs-popup>

            <!-- 取消订单弹窗 -->
            <vs-popup classContent="popup-example" title="取消订单" :active.sync="popupActive2Qxdd">
                <div class="modal-title" style="margin-left:22px">您正在取消订单，注意取消订单后将会同步到客户。系统会返回已扣除的资金和可购买量，请仔细操作！</div>
                <form class="frombox" style="margin-top:50px" id="data-list-list-view">
                    <vs-row>
                        <vs-col vs-w="3" class="colTitle">取消原因说明</vs-col>
                        <vs-col vs-w="9"><vs-input v-model="cancelModel" class="w-full" placeholder="输入取消原因" /></vs-col>
                    </vs-row>
                </form>
                <vs-row style="margin-top:20px">
                    <vs-col vs-w="2" vs-offset="4.5"><vs-button @click="OncancelOrder" color="primary" size="default" type="filled">确定</vs-button></vs-col>
                    <vs-col vs-w="2" vs-offset="0.01"><vs-button @click="Oncancelbtn" color="primary" size="default" type="border">取消</vs-button></vs-col>
                </vs-row>
            </vs-popup>

            <!-- 审核确认订单弹窗 -->
            <el-dialog class="verify examine" title="订单审核" classContent="popup-example" :visible.sync="isExamineOrder" :destroy-on-close="true">
                <el-table border ref="multipleTable" :data="examineList" tooltip-effect="dark" style="width: 100%" @selection-change="handleSelectionChange" :row-key="rowKey">
                    <el-table-column v-if="examineList.length > 1" :reserve-selection="true" type="selection" width="55"></el-table-column>
                    <el-table-column label="序号" type="index" width="50"></el-table-column>
                    <el-table-column label="审核内容">
                        <template slot-scope="scope">
                            <!-- {{ scope.row.date }} -->
                            <template>
                                <el-row class="marTop10" :gutter="20">
                                    <el-col :span="7" class="colTitle">订单编号：{{scope.row.orderNo}}</el-col>
                                    <el-col :span="7" class="colTitle">订单日期：{{scope.row.orderTime}}</el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="7" class="colTitle">买家名称：{{scope.row.buyerName}}</el-col>
                                    <el-col :span="7" class="colTitle">买家类型：{{scope.row.buyerType}}</el-col>
                                    <el-col :span="7" class="colTitle">买家留言：{{scope.row.buyerRemark}}</el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="7" class="colTitle">收货人姓名：{{scope.row.receiveName}}</el-col>
                                    <el-col :span="7" class="colTitle">收货人电话：{{scope.row.receivePhone}}</el-col>
                                    <el-col :span="7" class="colTitle">收货人地址：{{scope.row.province}}{{scope.row.city}}{{scope.row.area}}{{scope.row.address}}</el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="7" class="colTitle">需求部门：{{scope.row.fromDepart}}</el-col>
                                    <el-col :span="7" class="colTitle">需求人员：{{scope.row.fromUser}}</el-col>
                                    <el-col :span="7" class="colTitle">线下PI号：{{scope.row.piNo}}</el-col>
                                </el-row>
                            </template>
                            <el-table :data="scope.row.skuItems" border style="width: 90%;margin:10px 0;border-bottom:1px solid #EBEEF5;">
                                <el-table-column align="center" label="序号" type="index" width="50">
                                    <template slot-scope="scope">
                                        <span :class="scope.row.isAccord == 0 ? '' : 'danger-span'">{{scope.$index}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" prop="skuCode" label="商品编号" width="">
                                    <template slot-scope="scope">
                                        <span :class="scope.row.isAccord == 0 ? '' : 'danger-span'">{{scope.row.skuCode}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" prop="skuName" label="商品名称" width="">
                                    <template slot-scope="scope">
                                        <span :class="scope.row.isAccord == 0 ? '' : 'danger-span'">{{scope.row.skuName}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" prop="num" label="商品数量" width="">
                                    <template slot-scope="scope">
                                        <span :class="scope.row.isAccord == 0 ? '' : 'danger-span'">{{scope.row.num}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" prop="hitemPrice" label="实付金额" width="">
                                    <template slot-scope="scope">
                                        <span :class="scope.row.isAccord == 0 ? '' : 'danger-span'">{{scope.row.hitemPrice}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" prop="boxSpec" label="箱规" width="">
                                    <template slot-scope="scope">
                                        <span :class="scope.row.isAccord == 0 ? '' : 'danger-span'">{{scope.row.boxSpec}}{{scope.row.unit}}</span>
                                    </template>
                                </el-table-column>
                                <el-table-column align="center" prop="address" label="是否符合箱规">
                                    <template slot-scope="scope">
                                        <span :class="scope.row.isAccord == 0 ? '' : 'danger-span'">{{scope.row.isAccord == 0 ? '是' : '否'}}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <template>
                                <el-row class="marBottom10" :gutter="20">
                                    <el-col :span="3" class="">
                                        备注原因：<br>(<span style="color:#F56C6C">审核不通过必填</span>)
                                    </el-col>
                                    <el-col :span="10" class="colTitle">
                                        <textarea class="el-textarea__inner" v-model="scope.row.remark" type="textarea" :rows="2" placeholder="请输入审核内容"></textarea>
                                    </el-col>
                                </el-row>
                            </template>
                        </template>
                    </el-table-column>
                </el-table>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="AuditFailedOrder">审核不通过</el-button>
                    <el-button type="primary" @click="OnconfirmOrder(1)">审核通过</el-button>
                </span>
            </el-dialog>
        </div>
        <order-detail ref="orderDetail" @getstatussx="getstatussx"></order-detail>

    </div>
</template>

<script>
import orderDetail from '@/modules/order/orderDetail/orderDetail';

import store from './store.js';
import filterBoxOne from './filterBoxOne.vue';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import vSelect from 'vue-select';
import { OrderApi } from '@/modules/server-api/commodity-sys/order';
import { LogisticsApi } from '@/modules/server-api/commodity-sys/logistics';
import { CommodityGoodsyApi } from "@/modules/server-api/commodity-sys/goods-manage";
import { $busErrorCode, uploadHeader } from '@/modules/commodity-sys/common.js';
import {
    WmsWarehouseApi,
    Mod_Warehouse_Types_Options //库存类型
} from '@/modules/server-api/wms-manage/warehouse';
import { downloadFileTemplate, downloadExcel } from "@/utils/downloadExcel.js";
import { WmsStockApi } from "@/modules/server-api/wms-manage/stock";
import commondityTable from '@/modules/commodity-sys/components/commodity-table';

import VsTable from "./vsTable/vsTable"
import VsTd from "./vsTable/vsTd"
import VsTh from "./vsTable/vsTh"
import VsTr from "./vsTable/vsTr"

import CombineOrder from './components/CombineOrder'
import SearchInput from "@/modules/wms-manage/components/searchInput.vue";
import moment from "moment";
export default {
    components: {
        flatPickr,
        'v-select': vSelect,
        filterBoxOne,
        commondityTable,
        orderDetail,

        VsTable,
        VsTd,
        VsTh,
        VsTr,
        CombineOrder,
        SearchInput
    },
    computed:{
      // validDeliver(){
      //   return this.sendData.every(item => item.frtId)
      // },
      validateVerify() {
        // return (this.deliverParam.wsId !== '' && !this.deliverParam.locId !== ''  && this.deliverFlag)
        return (this.deliverParam.wsId !== '' && this.deliverParam.locId !== ''  && this.deliverParam.locId !== null)
      }
    },
    mixins: [store],
    beforeRouteEnter (to, from, next) {
        if(from.path != '/modules/order/orderDetail'){
            sessionStorage.removeItem("searchData")
            sessionStorage.removeItem("tabIndex")
            sessionStorage.removeItem("vsTabsList")
        }
        next()
    },
    data() {
        return {
            orderHeight: 0, //订单高度
            tabIndex:0,
            tabInfo:{
                id:0,
                supplierType:"全部",
                name:"全部",
                dealerType:""
                },
            orderSearchInfo:{}, //详情页过来的查询条件
            loadingasd:false,
            searchData: {
                orderNo: '', // 查询的订单编号
                payNo: '', //支付单号
                startTime: '', //下单开始日期
                endTime: '', //下单结束日期
                startPayTime: '', //付款开始日期
                endPayTime: '', //付款结束日期
                billSource: '', //订单来源
                orderStatusList: [], //订单状态
                sourceChannelList: [], //订单渠道
                categoryId: [], //商品分类
                buyerStoreCode: '', //门店编码
                skuCode: '', //物流编码
                skuName: '', //商品名称
                barCode: '', //商品69码
                paySource: '', //支付方式
                buyer:'', //买家名称id
                buyerCode: '', //买家编码
                buyerType: '', //买家类型
                buyerPhone: '', //买家手机号
                seller: '', //卖家名称id
                sellerCode: '', //卖家编码
                sellerPhone: '', //卖家手机号
                receiveName: '', //收货人姓名
                receivePhone: '', //收货人手机号
                province: '', //收货人省
                city: '', //收货人市
                area: '', //收货人区
                bodyId: '', //主体id
                currency: '', //币种
                dealerTypeList:[]
            },
            validDeliver: false,

            orderdatalist: [], //订单列表
            Orderselected: [], //选中的订单
            OrderReviewselected:[],//选中的审核
            pageshow:true,
            page: {
                // 分页
                pageNo: 1,
                pageSize: 20,
                totalCount: 0
            },
            clickOrderNo: '',
            // tabs todo-ljm
            vsTabsList:[
                {
                id:0,
                supplierType:"全部",
                name:"全部",
                dealerType:""
                }
            ],
            detailDataList: {}, //详情信息

            isShowPopImportOrder: false, //批量导入下单弹窗
            popupActive2Qxdd: false, //取消订单
            cancelModel: '', //取消订单原因

            judgeQxdd: '', //判断是多选删除还是反选删除
            totalCount: Number,

            deliverParam: {
                wsId: '',
                locId: ''
            },
            verifyConfirmId: [],
            sendData: [],
            stockData: [],
            stockTabledata: [], //隐藏没有发货的商品，临时存储
            skuCodes: [],
            sellerRemarkPop: false, //编辑卖家备注
            sellerRemark: '',
            tokenHeader: {},
            accept: '.excel, .xlsx',

            currencyTypeList:[
              {id: 'RMB', label: 'RMB', symbol:'￥'},
              {id: 'USD', label: 'USD', symbol:'$'}
            ],
            levelOne: ['一次性客户','内部客户','海外客户','省代PD','大零售商SCA','大连锁商SKA','CVS'],
            levelTwo: ['地代RD','省代下级零售商CA','省代下级无店商CAN'],
            levelThree: ['地代下级零售商CAD','地代下级无店商CAND'],
            levelStore:[ '专卖店', '明星店', '集合店', '直营店' ],
            buyerTypes: [],
            isExamineOrder: false, //审核弹窗
            examineList: [],  //审核订单列表
            examineRemark: '', //审核备注
            examineSelected: [], //选中审核订单列表
            OrderDetailSelected: [], //选中审核订单详情列表
            Purchaseorderlist:[],//商品信息列表

        };
    },
    created() {
        window.addEventListener('resize', this.getHeight) // 注册监听器
        this.getHeight();
        let tabsList = sessionStorage.getItem('vsTabsList')
        if (tabsList) {
            this.vsTabsList = JSON.parse(tabsList)
        } else {
          this.gitTabsList();
        }
        this.searchData.tabIndex = 0;
    },
    mounted(){
        // this.getOrderformList();
        let data = {};
        this.getBuyertype(data);
        let userState = JSON.parse(sessionStorage.getItem('user_state'));
        this.tokenHeader = {
            Authorization:userState.token
        }
    },
    methods: {
        //默认获取近一个月时间
        getBaseTime(){
            let end = new Date();
            let start = new Date();

            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            console.log(start,end);
            start = this.dateFormat("YYYY-mm-dd", start);
            end = this.dateFormat("YYYY-mm-dd", end);
            this.searchData.startTime = start;
            this.searchData.endTime = end;
            // this.searchData.startTime = start;
            // this.searchData.endTime = end;
        },
        dateFormat(fmt, date) {
            let ret;
            const opt = {
                "Y+": date.getFullYear().toString(),        // 年
                "m+": (date.getMonth() + 1).toString(),     // 月
                "d+": date.getDate().toString(),            // 日
                "H+": date.getHours().toString(),           // 时
                "M+": date.getMinutes().toString(),         // 分
                "S+": date.getSeconds().toString()          // 秒
                // 有其他格式化字符需求可以继续添加，必须转化成字符串
            };
            for (let k in opt) {
                ret = new RegExp("(" + k + ")").exec(fmt);
                if (ret) {
                    fmt = fmt.replace(ret[1], (ret[1].length == 1) ? (opt[k]) : (opt[k].padStart(ret[1].length, "0")))
                }
            }
            return fmt;
        },
        //鼠标移入表格事件
        async ncrFormat(row){
            this.loadingasd=true
            let data ={
                seller:row.seller,
                bodyId:row.bodyId,
                orderNos:[row.orderNo]
            }
            let res = await OrderApi.Purchaseorder(data);
            this.Purchaseorderlist=res.result
            this.loadingasd=false
            console.log(row)
        },
        getstatussx(){
            this.getOrderformList();
        },
        getHeight() {
            this.orderHeight = window.innerHeight - 230
        },
        selectCurrentChange(val) {
            this.Orderselected = val;
        },
        newCurrentChange(row) {
            this.$refs.orderListTable[0].toggleRowSelection(row)
        },
        tableRowClassName({row, rowIndex}) {
            if (row.availableAmount < row.num) {
                return 'amount-red';
            }
            return '';
        },

        expectation(){
        //    alert('敬请期待～')
        const h = this.$createElement;
            this.$message({
            message: h('p', null, [
                h('span', null, '当前功能 '),
                h('i', { style: 'color: teal' }, '敬请期待～')
            ])
            });
        },
        // 获取tab名称列表 todo
        async gitTabsList(){
            // this.vsTabsList = []
            let all = {
                id:0,
                supplierType:"全部",
                dealerType:""
            }
            let tabsList = this.vsTabsList;
            // 调接口赋值 todo
            let res = await OrderApi.getTabsList({});
            tabsList = res.result
            // 调接口赋值end todo
            tabsList.unshift(all)
            tabsList.map(tab =>{
                if (tab.dealerType == '') {
                    tab.dealerType = '下级'
                }
                if (tab.supplierType == '全部') {
                    tab.name = tab.supplierType
                } else {
                    tab.name = tab.supplierType + '→' + tab.dealerType
                }

            })
            this.vsTabsList = tabsList
            sessionStorage.setItem('vsTabsList', JSON.stringify(this.vsTabsList));

        },
        createOrder(){
            this.$router.push({ path: '/modules/order/createOrder'})
        },
        // ========= 右侧搜索
        async handleSearch(val) {
            console.log(val,"val============")
          //清空已选择的选项
            this.Orderselected = [];
            this.searchData = val;
            if (this.tabInfo.supplierType === '全部') {
                this.searchData.supplierType = ''
            } else {
                this.searchData.supplierType = this.tabInfo.supplierType
            }
            if (this.tabInfo.dealerType === '下级') {
                this.searchData.dealerType = ''
            } else if (this.tabInfo.dealerType === '门店') {
                this.searchData.dealerType = ''
            }else{
                this.searchData.dealerType =this.tabInfo.dealerType
            }
            console.log(val.isTab)
            if ( val.isTab ){
                this.setTabBuyerType(val);
            }else if(val.buyerType=='门店客户'){
                let list = await OrderApi.getBuyertype({cus_type: 2});
                let arr =[]
                console.log(this.buyerTypeList)
                list.result.map((item) => {
                    arr.push(
                        item.customer_name,
                    );
                });
                val.dealerTypeList = arr;
                // val.buyerType = null;
                this.page.pageNo = 1;
                this.getOrderformList();
            }else{
                if ( val.buyerType === '' || val.buyerType === null ){
                    this.tabIndex = val.tabIndex;
                    this.setTabBuyerType(val);
                }else{
                    val.dealerTypeList = [val.buyerType];
                    this.page.pageNo = 1;
                    this.getOrderformList();
                }
          }
          this.pageshow = false;//让分页隐藏
          this.$nextTick(() => {//重新渲染分页
              this.pageshow = true;
          });
        },
        //卖家类型
        async getBuyertype(data) {
            console.log(data,"data")
            let buyerTypeList = [];
            let res = await OrderApi.getBuyertype(data);
            res.result.map((item) => {
                buyerTypeList.push(
                item.customer_name,
                );
            });
            this.searchData.dealerTypeList = buyerTypeList;

            this.buyerTypes = buyerTypeList;
            this.page.pageNo = 1;
            this.getOrderformList();
        },

        setTabBuyerType(val) {
            let buyerType = null;
            let data = {};
            if (this.tabIndex === 4) {
                data = {
                cus_type: 2,
                };
            } else if (this.tabIndex === 1) {
                data = {
                level: 1,
                };
            } else if (this.tabIndex === 2) {
                data = {
                level: 2,
                cus_type: 1,
                };
            } else if (this.tabIndex === 3) {
                data = {
                level: 3,
                };
            } else if (this.tabIndex === 5) {
                data = {
                    level: 5,
                };
            } else {
                data = {};
            }
            this.getBuyertype(data);
            if (val.isTab) {
                // this.$refs.filterBoxOne.refreshBuyerType(this.buyerTypeList, this.tabIndex);
            }
        },
        // 切换tab
        orderTabChange(val,index){
            console.log(val,index)
            this.tabInfo = val;
            let info = this.searchData;
            info.dealerType = this.searchData.dealerType === '门店'? '' :this.searchData.dealerType;  //买家
            info.buyerType = ''; //左侧筛选的买家类型
            if (index !== 0) {
                info.supplierType = val.supplierType; //卖家
                if ( val.dealerType === '门店'){
                  info.dealerType = '' //买家
                }else {
                  info.dealerType = val.dealerType === '下级' ? '' : val.dealerType //买家
                }
            } else {
                info.supplierType = '';
                info.dealerType =''
            }
            info.isTab = true;
            //清空左侧筛选条件
            // this.$refs.filterBoxOne.emptyOrderSearch()
            this.handleSearch(info)
        },
        //导入文件
        uploadSuccess(response, file, fileList) {
            if (response.succ == 1 && response.code != $busErrorCode) {
                this.isShowPopImportOrder = false;
                this.$notifySuccess("导入成功")
                this.getOrderformList();
            } else {
                this.$notifyError(response.error || '导入数据格式错误,请修改后重新上传');
            }
        },

        // 确认取消
        cancelAffirm(tr,indextr){
            this.$alert('实付与成交金额不同，无法继续审核！', '提示', {
                confirmButtonText: '确定',
                callback: action => {}
                });
        },

        // 判断金额实付与订单总金额是否一致
        priceCompare(tr,indextr){
            if (tr.orderNo) {
                const temp = this.orderdatalist.filter(item => item.orderNo == tr.orderNo)
                if (temp) {
                    if (temp[0].toPayPrice != temp[0].realityTotalPrice) {
                      return this.cancelAffirm(tr,indextr)
                    } else {
                        this.verifyConfirm(tr,indextr);
                    }
                }
            }
        },

        //判断单据是否有非总部
        getExtraOrder(){
            const extraOrder = this.Orderselected.every(item => !item.sellerIsMe);
            let flag = true;
            if (extraOrder) {
                this.$notifyError('存在总部不可操作的订单，请重新选择');
                flag = false;
            }
            return flag;
        },

        //审核详情
        async handleReviewDetail(sendIds) {
            const res = await OrderApi.reviewDetails({orderNos: sendIds})
            if(res.succ === 1 && res.code == 0) {
                this.stockData = res.result
                this.stockData = res.result.map(item => {
                    return {
                        ...item,
                        newSendSkuName: '',
                        newSendAmount: ''
                    }
                })
                this.examineList = res.result.map(item => {
                    item.examine = true;
                    item.remark = '';
                    item.skuItems.map(skuitem => {
                        if((skuitem.num % skuitem.boxSpec) == 0){
                            skuitem.isAccord = 0
                        }else{
                            skuitem.isAccord = 1
                        }
                    })
                    return item;
                })
                this.stockTabledata = this.stockData;
                this.skuCodes = this.stockData.map(item =>{
                    return item.skuCode;
                });
                this.isExamineOrder = true;
            }else{
                return this.$notifyError(res.error);
            }
        },

        // 审核确认
        async verifyConfirm(tr, index) {
            let sendIds = []
            if (index === undefined) {
                if (this.Orderselected.length == 0) {
                    return this.$notifyError('请选择订单');
                }
                //校验是否是总部可操作的状态
                if(!this.getExtraOrder()){
                  return false;
                }
                const temp = this.Orderselected.every(item => item.orderStatus !== 'TO_REVIEW');
                if (temp) {
                    return this.$notifyError('选择的订单中有不可审核的订单，请重新选择');
                }
                sendIds = this.Orderselected.map(item => item.orderNo)
            } else {
                this.clickOrderNo = tr.orderNo
                sendIds = [tr.orderNo];
            }
            this.verifyConfirmId = sendIds
            this.skuCodes = [];
            this.stockData = [];
            this.$vs.loading();
            await this.handleReviewDetail(sendIds);
            this.$vs.loading.close()
        },

        //订单审核确认
        async OnconfirmOrder(type) {
            let orderParam = [];
            if (this.examineList.length > 1){
                if (this.OrderDetailSelected.length > 0) {
                    orderParam = this.OrderDetailSelected.map(item => {
                        let obj = {};
                        obj.orderNo = item.orderNo;
                        obj.status = type == 1 ? 'reviewed' : 'canceled';
                        obj.remark = type == 1 ? '' : item.remark;
                        return obj;
                    });
                } else {
                    return this.$notifyError('请选择订单审核内容');
                }
            }else{
                orderParam = this.examineList.map(item => {
                    let obj = {};
                    obj.orderNo = item.orderNo;
                    obj.status = type == 1 ? 'reviewed' : 'canceled';
                    obj.remark = type == 1 ? '' : item.remark;
                    return obj;
                });
            }

            const params = orderParam;
            const res = await OrderApi.batchReviews(params)
            if(res.succ === 1) {
                this.$notifySuccess('审核成功');
                if(this.examineList.length > 1 && this.examineList.length != this.OrderDetailSelected.length && type == 1){
                    let examineList = []
                    examineList = this.examineList.concat(this.OrderDetailSelected).filter(function(v, i, arr){
                        return arr.indexOf(v) === arr.lastIndexOf(v);
                    })
                    // console.log(examineList)
                    this.examineList = examineList;
                }else{
                    this.isExamineOrder = false;
                }
            } else {
                this.$notifyError(res.error);
                this.isExamineOrder = false;
            }
            this.clickOrderNo = '';
            this.Orderselected = [];
            this.getOrderformList();
        },

        // 审核不通过
        AuditFailedOrder(){
            let examineList = [];
            if(this.examineList.length > 1){
                if(this.OrderDetailSelected.length > 0){
                    examineList = this.examineList.map(item => {
                        this.OrderDetailSelected.map(ele => {
                            if(item.orderNo == ele.orderNo){
                                item.examine = false;
                                this.$set(item, item.examine, false);
                            }
                        })
                        return item;
                    })
                }else{
                    return this.$notifyError('请选择订单审核内容');
                }
            }else{
                examineList = this.examineList;
                examineList.map(item => {
                    item.examine = false
                    this.$set(item, item.examine, false);
                });
            }
            this.examineList = examineList
            let orList = examineList.filter(item => !item.examine);
            let orRemark = examineList.filter(item => (!item.examine && item.remark));
            this.OrderDetailSelected = orList;
            if(orList.length > 0 && orRemark.length > 0 && orList.length == orRemark.length){
                this.OnconfirmOrder(2);
            }else{
                this.$notifyError('请输入备注原因');
            }
        },

        // 取消订单
        cancelOrder(tr, index) {
            if (index === undefined) {
                if (this.Orderselected.length == 0) {
                    return this.$notifyError('请选择订单');
                }
                //校验是否是总部可操作的状态
                if(!this.getExtraOrder()){
                  return false;
                }
                const temp = this.Orderselected.filter(item => item.orderStatus === 'CANCEL_ED');
                if (temp.length) {
                    return this.$notifyError('选择的订单中有不可取消的订单，请重新选择');
                }
            } else {
                this.clickOrderNo = tr.orderNo;
            }
            this.popupActive2Qxdd = true;
            this.cancelModel='';
            this.judgeQxdd = false;
        },


        // ============================ 列表相关
        //更改每页条数
        handleSizeChange(val){
          this.page.pageSize = val;
          this.getOrderformList();
        },
        handleCurrentChange(val){
          this.page.pageNo = val;
          this.getOrderformList();
        },
        //订货单列表查询
        async getOrderformList() {
            this.$vs.loading();
            // this.getBaseTime();
            let data = {
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
                data: this.searchData,
            }
            if(this.tabIndex == 0 && !this.searchData.buyerType){
                data.data.dealerTypeList = [];
            }
            if(this.searchData.buyerType == '门店客户'){
                data.data.buyerType = '';
            }
            // let searchInfo = sessionStorage.getItem('searchData') //本地存储的搜索info
            // this.orderSearchInfo = JSON.parse(searchInfo)  //从详情带过来的查询条件
            //   判断是否从详情页返回，如果是就保留之前查询条件
            if(this.tabIndex !== 0){
                data.data.dealerTypeList = data.data.dealerTypeList.length === 0 ?['']:data.data.dealerTypeList;
            }

            let res = await OrderApi.OrderformList(data);
            //增加币种
            let resData = res.result.list;
            if(resData.length){
              resData = resData.map(data =>{
                let currSku = data.skuItems;
                if(currSku.length > 0){ //获取金额标识符
                  let currCurrency = data.skuItems ? data.skuItems[0].currency : this.currencyTypeList[0].id;
                  let cIndex = this.currencyTypeList.findIndex(item => item.id == currCurrency);
                  data.currency = cIndex > -1 ?  currCurrency : this.currencyTypeList[0].id;
                  cIndex = cIndex > -1 ? cIndex : 0;
                  data.currencySymbol = this.currencyTypeList[cIndex].symbol;
                }
                return data;
              });
            }
            this.orderdatalist = resData;
            this.page.totalCount = res.result.totalCount;
            this.$vs.loading.close();
        },
        orderThStyle(thname) {
            let style = ''
            if(thname == "实付" || thname == "应付"){
                style = 'price-right'
            } else {
                style = 'fixed-table-column whit'
            }
            return style;
        },
        orderStatusColorStyle(status) {
            const statusMaps = [
                {
                    key: 'TO_PAY',
                    style: 'background: #ecfa0c'
                },
                {
                    key: 'TO_REVIEW',
                    style: 'background: #FF8D23'
                },
                {
                    key: 'REVIEW_ED',
                    style: 'background: #74db41'
                },
                {
                    key: 'COMBINE_ED',
                    style: 'background: #A1A7B4'
                },
            ]
            // const statusInfo =  this.orderStatusList.find(item => item.value === status)
            const map = statusMaps.find(item => item.key === status)
            if(map) {
                return map.style
            }
        },

        // 点击编辑
        handleEdit(str, index) {
            // this.addPopupActive = true
            // this.detailDataList = str
        },
        // 查看
        handleCheck(str, index, editFlag) {
            sessionStorage.setItem('detail', JSON.stringify(str));
            sessionStorage.setItem('editFlag', editFlag);
            sessionStorage.setItem('orderTypeEdit', 'order')
            this.$refs.orderDetail.getData()
            // this.$router.push({ path: '/modules/order/orderDetail' }).catch(() => {});

        },

        // 弹窗相关
        // 关闭查看。编辑弹窗
        close() {
            this.addPopupActive = false;
        },

        //取消订单
        async OncancelOrder() {
            let orderNos = [];
            if (!this.clickOrderNo) {
                this.Orderselected.map(item => {
                    orderNos.push(item.orderNo);
                    return item;
                });
            } else {
                orderNos.push(this.clickOrderNo);
            }
            let res = await OrderApi.cancelNewOrderChoice({
                orderNos: orderNos,
                warnMessage: this.cancelModel
            });
            if (res.succ == 1) {
                this.popupActive2Qxdd = false;
                this.$notifySuccess('取消成功');
            } else {
                this.$notifyError(res.error);
                this.popupActive2Qxdd = false;
            }
            this.clickOrderNo = '';
            this.Orderselected = [];
            this.getOrderformList();
        },

        //取消取消订单
        Oncancelbtn() {
            this.clickOrderNo = '';
            this.popupActive2Qxdd = false;
        },


        // 调接口获取发货弹窗详情
        async getSentDetail(sendIds) {
            const res = await OrderApi.queryDeliveryOrder({orderNos: sendIds})
            if(res.succ === 1) {
                this.sendData = res.result
            }
        },

        /* 仓位库存颜色判断逻辑：
         * 需求：判断每个仓位可用库存是否大于发货数量，如果仓位库存大于/等于发货数量，显示绿色；
         * 逻辑：库存是否充足判断：（如发货数量5箱10盒）
         *  箱库存大于等于发货数量的箱（即>= 5） && 盒库存大于等于发货数量的盒（即>=10）
         * 如果小于，显示黑色；
         * sendSku: 发货箱数量
         * sendSkuBox: 发货盒数量
         * skuStock: 当前仓位箱库存
         * skuBoxStock: 当前仓位盒库存
         * boxSpec: 箱规
         */
        currStockFit(sendSku, sendSkuBox, skuStock, skuBoxStock, boxSpec){
          let fitFlag = false;
          if(Number(skuStock) >= Number(sendSku) && Number(skuBoxStock) >= Number(sendSkuBox)){
            fitFlag = true;
          }
          return fitFlag;
        },

        //编辑卖家备注
        editBuyerRemark(tr) {
            this.sellerRemark = tr.sellerRemark;
            this.clickOrderNo = tr.orderNo;
            this.sellerRemarkPop = true;
        },
        //保存卖家备注
        async saveSellerRemark() {
            if (this.sellerRemark == '') {
                this.$notifyError('请填写备注信息');
            } else if (this.clickOrderNo == '') {
                this.$notifyError('订单编号获取失败');
            } else {
                let res = await OrderApi.updateOrderInfo({
                    invoiceNo: this.clickOrderNo,
                    sellerRemark: this.sellerRemark
                });
                this.sellerRemarkPop = false;
                if (res.succ == 1) {
                    this.$notifySuccess('保存成功');
                    this.sellerRemark = '';
                    this.getOrderformList();
                } else {
                    this.$notifyError(res.error);
                }
            }
        },
        async download() {
            //组装下载参数
            let param = {};
            param = this.searchData;
            param.supplierType = this.searchData.supplierType;  //买家类型
            param.dealerTypeList = this.searchData.dealerTypeList;
            param.tabIndex = this.tabIndex;
            if(this.Orderselected.length != 0){
                let orderNos = this.Orderselected.map(item => { return item.orderNo })
                param.orderNos = orderNos;
            }
            console.log(param);
            let url = '/data-dist/api/dist/ordering/export/newOrderDownload';
            let fileName = '订单列表导出.xlsx';

            // downloadExcel(url, param, fileName);

            const res = await OrderApi.orderdaochu(param)
            if(res.code=='0'){
                this.$notifySuccess(res.result)
            }else{
                this.$notifyError(res.error);
            }

        },
        //下载文件模板
        downloadTemplate(){
            downloadFileTemplate('/data-dist/api/dist/down/template/yooz_ordering', '订单导入模板.xlsx');
        },

        /********  订货单二期功能 ************* */
        //选中的审核订单详情
        handleSelectionChange(val){
            this.OrderDetailSelected = val;
        },
        rowKey(row) {
            return row.orderNo
        },


    },
    watch: {
        // page: {
        //     handler() {
        //         this.getOrderformList();
        //     },
        //     deep: true
        // },
        sendData: {
            handler() {
              this.validDeliver = this.sendData.every(item => item.frtId)
            },
            deep: true
        },
        isExamineOrder(val){
            if(!val){
                this.OrderDetailSelected = [];
            }
        }
        // examineList(val){
        //     this.examineList = val;
        // }
    }

};
</script>



<style lang="scss" scoped>
@import '../order/order.scss';
@import '@/modules/commodity-sys/commodity.scss';
/deep/.vs-con-dropdown {
    line-height: 11px;
}
.search-item-border {
    border-radius: 0 !important;
    padding-right: 15px;
    margin-right: 10px;
    border-right: 1px solid #000;
}
.search-item-right {
    padding-left: 10px;
    border-left: 1px solid #000;
    display: flex;
    position: absolute;
    right: 0;
}
.expectation {
    color: #ccc !important;
}
/deep/ .deliver-pop {
  position: relative;
  /deep/ .v-select {
      width: 350px;
  }
  button {
    width: 126px;
    height: 38px;
    font-size: 14px;
  }
}
// /deep/ .vs-dialog .vs-table--content {
//     height: 400px !important;
// }
/deep/ .remark-text span {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
}
.deliver-dialog{
  min-width: 800px;
}
.colTitle {
  line-height: 37px;
}
.deliver-btn {
  width: 100%;
  button {
      width: 126px;
      height: 38px;
      font-size: 14px;
  }
}
.edit-remark-textarea {
    width: 100%;
}
.follow-detail {
    .timeline-wrapper {
        width: 80%;
        margin: 0 auto;
        padding-top: 10px;
        max-height: 400px;
        overflow-y: auto;
        .addressee {
            display: flex;
            width: 80%;
            min-height: 50px;
            padding: 0 1.5rem 1rem 1.5rem;
            position: relative;
            left: 20%;
            .addressee-line {
                position: absolute;
                top: 5px;
                left: 0;
                width: 1px;
                height: 100%;
                background: #ebe9f1;
            }
            .addressee-item-point {
                position: absolute;
                width: 20px;
                height: 20px;
                top: 0px;
                z-index: 1;
                left: -10px;
                text-align: center;
                border-radius: 50%;
                background-color: rgb(64, 144, 255);
                span {
                    text-align: center;
                    font-size: 12px;
                    line-height: 20px;
                    color: #fff;
                }
            }
            .addressee-item-content {
                font-size: 12px;
            }
        }
    }
}
.excrete-logo{
    display: inline-block;
    padding: 0;
    width: 20px;
    height: 20px;
    text-align: center;
    background: rgb(64,144,255);
    font-size: 13px;
    line-height: 20px;
    color: white;
    border-radius: 50%;
}
.el-table {
    // border: none;
    /deep/ .el-table__row {
        .cell {
            white-space: pre-wrap;
        }
    }
    &::before {
        // border: none;
        height: 0;
    }
}
.buyerName {
    color: #222;
}
.buyerType {
    font-size: 12px;
    color: #aaa;
}
.price-right {
    /deep/.vs-table-text {
        display: block;
        text-align: right;
    }
}
/deep/.vs-table--thead th {
    background: #fff;
}
.fixed-table-column {
    background: #fff !important;
}
.orderbox /deep/.vs-tabs--li {
    margin-right: 10px !important;
}

</style>

<style lang="scss">

.el-textarea__inner.is-disabled {
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    cursor: not-allowed;
}
.el-textarea__inner {
    padding: 5px 15px;
    background-image: none;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    display: block;
    resize: vertical;
    line-height: 1.5;
    box-sizing: border-box;
    width: 100%;
    font-size: 12px;
    color: #606266;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    font-family: "Montserrat", Helvetica, Arial, sans-serif;
    font-weight: 400;
}
.danger-span{
    color: #F56C6C;
}
.el-table__empty-block{
    border-bottom: 1px solid #EBEEF5;
}
.el-table__empty-text{
    width: 100%;
}
.el-table__row:hover>td{
    background-color: #ecf5ff;
}
.el-table th>.cell{
    font-weight: bold;
    color: #333;
}
.el-table .cell{
    font-size: 12px;
}
.verify {
    .el-dialog {
        // height: 90vh;
        width: auto;
        max-width:  1100px;
        .el-dialog__body {
            min-height: 400px;
            max-height: 600px;
            overflow-y: auto;
        }
        .el-table__row {
            font-size: 12px;
        }
        .el-table td {
            padding: 2px 0 !important;
        }
        .el-table__body-wrapper {
            height: calc(100% - 50px);
            overflow-y: auto;
        }
    }
}
.el-select-dropdown {
    min-width: none !important;
    width: 200px !important;
}
.el-table .amount-red{
  color: #F56C6C;
}
</style>
